import React from "react";
import {List} from "../modules/PaymentCycles";

export function PaymentCyclesListPage() {
  return (
    <List />
  );
}
